import React, { useRef } from 'react';
import styled from 'styled-components';
import flagSprite from '@lt/components/components/Flags';

import { useIntersectionObserver } from 'usehooks-ts';

import type { ICountry } from './types';

interface ICountriesList {
  className?: string;
  isMobile?: boolean;
  countries: ICountry[];
}

export const CountriesList = (props: ICountriesList) => {
  const { className, countries = [], isMobile = false } = props;

  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(ref, {
    freezeOnceVisible: true,
  });
  const isVisible = !!entry?.isIntersecting;

  if (countries.length === 0) return null;

  return (
    <Container
      className={className}
      ref={ref}
      $isMobile={isMobile}
      $isFlagSprite={isVisible}
    >
      {countries.map((item) => {
        const { link, text, iso2 } = item;

        return (
          <CountryLink key={iso2} href={link} $isMobile={isMobile}>
            {isVisible && (
              <StyledFlag
                className={`lt-flag lt-flag-${iso2?.toLowerCase() || 'us'}`}
              />
            )}

            {text}
          </CountryLink>
        );
      })}
    </Container>
  );
};

const Container = styled.div<{ $isMobile: boolean; $isFlagSprite: boolean }>`
  font-size: 0;

  ${({ $isFlagSprite }) => ($isFlagSprite ? flagSprite() : '')}

  ${({ $isMobile }) =>
    $isMobile
      ? `
    max-width: 300px;
    margin: 5px auto;
    padding-bottom: 50px;
  `
      : `
    width: 900px;
    margin: 0 auto 50px;
    padding-left: 30px;
  `}
`;

const CountryLink = styled.a<{ $isMobile: boolean }>`
  width: 20%;
  display: inline-block;
  font-size: 15px;
  text-decoration: none;
  color: #434343;
  vertical-align: middle;
  margin: 4px 0;

  ${({ $isMobile }) =>
    $isMobile &&
    `
    width: 130px;
    margin: 10px 0 10px 20px;
  `}
`;

const StyledFlag = styled.div`
  vertical-align: top;
  margin-right: 7px;
`;
